module.exports = __webpack_public_path__ + "img/model15_ug.1217434d.jpg";